import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import { configureSentry } from '@shared/modules/sentry/utils';

configureSentry();

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(<App />);
}
